import type { AppConfig } from './app.config';
import { resolveConfig } from './configs';

/**
 * Loads the application configuration by resolving the current hostname
 * to the appropriate environment config. No network request needed.
 *
 * @returns The loaded AppConfig
 */
export function loadConfig(): AppConfig {
	const config: AppConfig = { ...resolveConfig() };

	// Inject environment variables if they exist (build-time esbuild defines)
	if (process.env.SP_API_ROOT) {
		config.staticApiRoot = process.env.SP_API_ROOT;
	}
	if (process.env.SP_DISCOVERY_URL) {
		config.discoveryBaseUrl = process.env.SP_DISCOVERY_URL;
	}
	if (process.env.SP_BASE_PATH) {
		config.basePath = process.env.SP_BASE_PATH;
	}
	if (process.env.SP_WS_URL) {
		config.staticWsUrl = process.env.SP_WS_URL;
	}

	console.log('[Config] Configuration loaded successfully', config);

	return config;
}
